import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { TagDeleteDto, TagEditDto } from '@interfaces-clean/subject-monitoring.interface';
import { TagDto, TagPostDto } from '@interfaces-clean/tags.interface';
import { getData, postData } from '@apis/rest-client';

const tagUrlPrefix = 'Tag';
const timeout = 30000;

export const TagAPI = {
    useGetAllTags: (studyRef: string, timestamp?: string) => {
        const getAllUrl = timestamp ? `${tagUrlPrefix}/${studyRef}/${timestamp}` : `${tagUrlPrefix}/${studyRef}`;
        return useSWRMutation(getAllUrl, (url: string) => {
            return getData<TagDto[]>(url, { timeout });
        });
    },

    useGetAllTagsQuery: (studyRef: string, timestamp?: string) => {
        const key = timestamp ? `${tagUrlPrefix}/${studyRef}/${timestamp}` : `${tagUrlPrefix}/${studyRef}`;

        return useSWR(key, (url) => {
            return getData<TagDto[]>(url, { timeout });
        });
    },

    usePostTag: (studyRef: string, timestamp?: string) => {
        const postUrl = timestamp
            ? `${tagUrlPrefix}/AddSingle/${studyRef}/${timestamp}`
            : `${tagUrlPrefix}/AddSingle/${studyRef}`;
        return useSWRMutation(postUrl, (url: string, { arg }: { arg: TagPostDto }) => {
            return postData<TagPostDto, boolean>(url, { arg, timeout });
        });
    },

    useDeleteTag: (studyRef: string) => {
        const postUrl = `${tagUrlPrefix}/Delete/${studyRef}`;
        return useSWRMutation(postUrl, (url: string, { arg }: { arg: TagDeleteDto }) => {
            return postData<TagDeleteDto, boolean>(url, { arg, timeout });
        });
    },

    useUpdateTag: (studyRef: string) => {
        const postUrl = `${tagUrlPrefix}/Update/${studyRef}`;
        return useSWRMutation(postUrl, (url: string, { arg }: { arg: TagEditDto }) => {
            return postData<TagEditDto, boolean>(url, { arg, timeout });
        });
    },
} as const;
